document.addEventListener('DOMContentLoaded', function () {
    let map;
    let marker = null;
    let selectedParcelLayer = null;
    let currentLocationData = null;
    let geocodeTimeout;
    let geocodeAbortController;
    let highlightedIndex = -1;
    let isPopupOpen = false;

    const addressInput = document.getElementById('address-input');
    const addressError = document.getElementById('address-error');
    const addressSuggestions = document.getElementById('address-suggestions');
    const addressLoadingSpinner = document.getElementById('address-loading-spinner');
    const btnGeolocate = document.getElementById('btn-geolocate');
    const btnGeolocateText = document.getElementById('btn-geolocate-text');
    const btnGeolocateSpinner = document.getElementById('btn-geolocate-spinner');
    const inputWrapper = document.querySelector(".map-search-wrapper");
    const dropdownContent = document.getElementById("dropdown-content");

    const customMarkerIcon = L.divIcon({
        html: `<svg style="display: block; z-index: 9999; position: relative;" role="img" aria-label="Wybrana lokalizacja" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title>Wybrana lokalizacja</title>
                <path d="M13.5 9.9668L12.0375 23.7803C12.0375 23.7889 12.0341 23.7971 12.0281 23.8031C12.022 23.8091 12.0138 23.8125 12.0052 23.8125C11.9967 23.8125 11.9885 23.8091 11.9824 23.8031C11.9764 23.7971 11.973 23.7889 11.973 23.7803L10.5 9.9668C11.4605 10.3645 12.5395 10.3645 13.5 9.9668Z" fill="#DB1745"/>
                <path d="M12.0064 23.9999C11.9517 23.9995 11.8992 23.9789 11.8588 23.9421C11.8184 23.9053 11.7931 23.8548 11.7878 23.8004L10.3125 9.98655C10.3092 9.95416 10.3143 9.92146 10.3275 9.89168C10.3406 9.86189 10.3613 9.83604 10.3875 9.81668C10.4135 9.79722 10.4441 9.78486 10.4763 9.78078C10.5085 9.7767 10.5412 9.78106 10.5713 9.79343C11.4864 10.1706 12.5136 10.1706 13.4288 9.79343C13.4587 9.78113 13.4914 9.77681 13.5235 9.78089C13.5556 9.78496 13.5862 9.79729 13.6121 9.81668C13.6383 9.83604 13.659 9.86189 13.6721 9.89168C13.6853 9.92146 13.6905 9.95416 13.6871 9.98655L12.225 23.8001C12.2198 23.8545 12.1946 23.905 12.1543 23.9419C12.114 23.9789 12.0614 23.9995 12.0068 23.9999H12.0064ZM10.7186 10.2472L12.0056 22.3083L13.2806 10.2468C12.4485 10.5198 11.5509 10.5199 10.7186 10.2472Z" fill="#DB1745"/>
                <path d="M12.0004 9.52425C14.5162 9.52425 16.5556 7.43415 16.5556 4.85588C16.5556 2.2776 14.5162 0.1875 12.0004 0.1875C9.48471 0.1875 7.44531 2.2776 7.44531 4.85588C7.44531 7.43415 9.48471 9.52425 12.0004 9.52425Z" fill="#DB1745"/>
                <path d="M11.9997 9.7125C10.7273 9.69589 9.51347 9.1753 8.62439 8.26492C7.7353 7.35453 7.24359 6.12868 7.25711 4.85625C7.24359 3.58382 7.7353 2.35797 8.62439 1.44759C9.51347 0.537201 10.7273 0.0166103 11.9997 0C13.2721 0.0166103 14.486 0.537201 15.3751 1.44759C16.2642 2.35797 16.7559 3.58382 16.7424 4.85625C16.7559 6.12868 16.2642 7.35453 15.3751 8.26492C14.486 9.1753 13.2721 9.69589 11.9997 9.7125ZM11.9997 0.375C10.8268 0.391602 9.7083 0.872681 8.88955 1.71274C8.07079 2.5528 7.61859 3.68327 7.63211 4.85625C7.61849 6.02926 8.07065 7.15979 8.88943 7.99987C9.70821 8.83995 10.8268 9.321 11.9997 9.3375C13.1727 9.321 14.2912 8.83995 15.11 7.99987C15.9288 7.15979 16.381 6.02926 16.3674 4.85625C16.3809 3.68327 15.9287 2.5528 15.1099 1.71274C14.2912 0.872681 13.1727 0.391602 11.9997 0.375Z" fill="#DB1745"/>
        </svg>`,
        className: 'custom-map-marker',
        iconSize: [24, 24],
        iconAnchor: [12, 24],
        popupAnchor: [0, -24]
    });

    function updateZoomControls() {
        const zoomControl = map?.getContainer().querySelector('.leaflet-control-zoom');
        if (!zoomControl) return;

        const isMobile = window.innerWidth < 768;
        const isSearchActive = !dropdownContent.classList.contains('sugg-hidden');

        if (isSearchActive) {
            setZoomVisibility(zoomControl, false);
            return;
        }

        if (isPopupOpen) {
            if (isMobile) {
                setZoomVisibility(zoomControl, false);
            } else {
                setZoomVisibility(zoomControl, true);
            }
            return;
        }

        setZoomVisibility(zoomControl, true);
    }

    function setZoomVisibility(element, show) {
        element.style.opacity = show ? '1' : '0';
        element.style.pointerEvents = show ? 'auto' : 'none';
    }

    window.addEventListener('resize', updateZoomControls);

    addressInput.addEventListener("focus", () => {
        dropdownContent.classList.remove("sugg-hidden");
        updateZoomControls();
    });

    document.addEventListener("click", (e) => {
        if (inputWrapper && !inputWrapper.contains(e.target)) {
            dropdownContent.classList.add("sugg-hidden");
            addressSuggestions.classList.add('sugg-hidden');
            addressInput.setAttribute('aria-expanded', 'false');
            btnGeolocate.classList.remove('sugg-has-results');
            updateZoomControls();
        }
    });

    inputWrapper.addEventListener('focusout', (e) => {
        setTimeout(() => {
            if (!inputWrapper.contains(document.activeElement)) {
            }
        }, 0);
    });

    function setLoadingState(button, textElement, spinnerElement, isLoading) {
        if (isLoading) {
            button.disabled = true;
            if (textElement) textElement.classList.add('sugg-hidden');
            if (spinnerElement) spinnerElement.classList.remove('sugg-hidden');
        } else {
            button.disabled = false;
            if (textElement) textElement.classList.remove('sugg-hidden');
            if (spinnerElement) spinnerElement.classList.add('sugg-hidden');
        }
    }

    function formatPhotonAddress(properties) {
        const { name, street, housenumber, city, country } = properties;
        let address = name || '';
        if (street) address += (address ? ', ' : '') + `${street} ${housenumber || ''}`;
        if (city && !address.includes(city)) address += (address ? ', ' : '') + city;
        return address.trim() || country || '';
    }

    function selectSuggestion(lat, lon, addressLabel) {
        addressInput.value = addressLabel;
        currentLocationData = { lat, lon, address: addressLabel };
        dropdownContent.classList.add('sugg-hidden');
        addressSuggestions.classList.add('sugg-hidden');
        addressInput.setAttribute('aria-expanded', 'false');
        btnGeolocate.classList.remove('sugg-has-results');
        updateZoomControls();
        updateMapPosition({ lat, lng: lon });
    }

    addressInput.addEventListener('input', () => {
        const query = addressInput.value.trim();

        clearTimeout(geocodeTimeout);
        if (geocodeAbortController) {
            geocodeAbortController.abort();
        }

        addressSuggestions.classList.add('sugg-hidden');
        addressSuggestions.innerHTML = '';
        addressError.textContent = '';
        highlightedIndex = -1;
        currentLocationData = null;
        addressInput.removeAttribute('aria-activedescendant');
        addressInput.setAttribute('aria-expanded', 'false');
        btnGeolocate.classList.remove('sugg-has-results');

        if (query.length < 3) {
            addressLoadingSpinner.classList.add('sugg-hidden');
            addressError.innerHTML = '';
            return;
        }

        geocodeTimeout = setTimeout(() => {
            addressLoadingSpinner.classList.remove('sugg-hidden');
            geocodeAbortController = new AbortController();
            const signal = geocodeAbortController.signal;

            const endpoint = `https://photon.komoot.io/api/?q=${encodeURIComponent(query)}&limit=15&bbox=16.81,51.02,17.25,51.21`;

            fetch(endpoint, { signal })
                .then(response => response.json())
                .then(data => {
                    const uniqueLabels = new Map();
                    addressSuggestions.innerHTML = '';
                    if (data.features) {
                        data.features.forEach(feature => {
                            const addressLabel = formatPhotonAddress(feature.properties);
                            if (addressLabel && !uniqueLabels.has(addressLabel)) {
                                uniqueLabels.set(addressLabel, feature);
                            }
                        });
                    }

                    if (uniqueLabels.size > 0) {
                        let i = 0;
                        uniqueLabels.forEach((feature, addressLabel) => {
                            const item = document.createElement('div');
                            item.className = 'sugg-suggestion-item';
                            item.textContent = addressLabel;
                            item.setAttribute('role', 'option');
                            item.setAttribute('tabindex', '0');
                            item.id = `suggestion-${i++}`;

                            item.addEventListener('click', () => {
                                const [lon, lat] = feature.geometry.coordinates;
                                selectSuggestion(lat, lon, addressLabel);
                            });

                            item.addEventListener('keydown', (e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    const [lon, lat] = feature.geometry.coordinates;
                                    selectSuggestion(lat, lon, addressLabel);
                                }
                            });

                            addressSuggestions.appendChild(item);
                        });
                        addressSuggestions.classList.remove('sugg-hidden');
                        btnGeolocate.classList.add('sugg-has-results');
                        addressInput.setAttribute('aria-expanded', 'true');

                        dropdownContent.classList.remove('sugg-hidden');
                        updateZoomControls();
                    } else {
                        addressError.textContent = 'Nie znaleziono adresu. Możesz kliknąć na mapie.';
                        dropdownContent.classList.remove('sugg-hidden');
                        updateZoomControls();
                    }
                })
                .catch(error => {
                    if (error.name === 'AbortError') {
                        return;
                    }
                    // console.error('Błąd autouzupełniania:', error);
                    addressError.textContent = 'Błąd wyszukiwania. Spróbuj ponownie.';
                    dropdownContent.classList.remove('sugg-hidden');
                })
                .finally(() => {
                    addressLoadingSpinner.classList.add('sugg-hidden');
                });
        }, 250);
    });

    addressInput.addEventListener('keydown', (e) => {
        const suggestions = document.querySelectorAll('.sugg-suggestion-item');

        if (suggestions.length === 0) return;

        let newIndex = highlightedIndex;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            newIndex = (highlightedIndex + 1) % suggestions.length;
            updateHighlight(newIndex, suggestions);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            newIndex = (highlightedIndex - 1 + suggestions.length) % suggestions.length;
            updateHighlight(newIndex, suggestions);
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (highlightedIndex > -1) {
                suggestions[highlightedIndex].click();
            }
        } else if (e.key === 'Escape') {
            dropdownContent.classList.add('sugg-hidden');
            addressSuggestions.classList.add('sugg-hidden');
            addressInput.setAttribute('aria-expanded', 'false');
            btnGeolocate.classList.remove('sugg-has-results');
            updateZoomControls();
        }
    });

    function updateHighlight(index, suggestions) {
        if (highlightedIndex > -1 && suggestions[highlightedIndex]) {
            suggestions[highlightedIndex].classList.remove('sugg-highlighted');
        }
        highlightedIndex = index;
        if (suggestions[highlightedIndex]) {
            suggestions[highlightedIndex].classList.add('sugg-highlighted');
            suggestions[highlightedIndex].scrollIntoView({ block: 'nearest' });
            addressInput.setAttribute('aria-activedescendant', suggestions[highlightedIndex].id);
        }
    }

    btnGeolocate.addEventListener('click', () => {
        if (!navigator.geolocation) {
            addressError.textContent = 'Geolokalizacja nie jest wspierana przez Twoją przeglądarkę.';
            dropdownContent.classList.remove('sugg-hidden');
            return;
        }

        setLoadingState(btnGeolocate, btnGeolocateText, btnGeolocateSpinner, true);
        addressError.textContent = '';
        addressInput.value = '';

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                const endpoint = `https://photon.komoot.io/reverse?lon=${longitude}&lat=${latitude}`;

                fetch(endpoint)
                    .then(response => response.json())
                    .then(data => {
                        let address = 'Twoja przybliżona lokalizacja';
                        if (data.features && data.features.length > 0) {
                            address = formatPhotonAddress(data.features[0].properties);
                        }
                        addressInput.value = address;
                        currentLocationData = { lat: latitude, lon: longitude, address: address };
                        updateMapPosition({ lat: latitude, lng: longitude });
                    })
                    .catch(error => {
                        // console.error('Błąd reverse geocoding:', error);
                        addressError.textContent = 'Nie udało się pobrać nazwy adresu.';
                        currentLocationData = { lat: latitude, lon: longitude, address: 'Twoja lokalizacja' };
                        updateMapPosition({ lat: latitude, lng: longitude });
                    })
                    .finally(() => {
                        setLoadingState(btnGeolocate, btnGeolocateText, btnGeolocateSpinner, false);
                    });
            },
            (error) => {
                let errorMsg = 'Wystąpił nieznany błąd lokalizacji.';
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        errorMsg = 'Odmówiono dostępu do lokalizacji.';
                        break;
                    case error.POSITION_UNAVAILABLE:
                        errorMsg = 'Informacje o lokalizacji są niedostępne.';
                        break;
                    case error.TIMEOUT:
                        errorMsg = 'Przekroczono czas oczekiwania na lokalizację.';
                        break;
                }
                addressError.textContent = errorMsg;
                dropdownContent.classList.remove('sugg-hidden');
                setLoadingState(btnGeolocate, btnGeolocateText, btnGeolocateSpinner, false);
            }
        );
    });

    function buildPopupHtmlFromTwigLogic(data) {
        if (data.errorMessage) {
            return `
            <div style="padding: 5px 0;">
                <h3 style="font-weight: 600; font-size: 16px; margin-bottom: 4px; color: #1f2937;">Błąd</h3>
                <p style="font-size: 14px; margin: 0; color: #4b5563;">Nie udało się pobrać danych dla wskazanej lokalizacji.</p>
            </div>`;
        }

        if (data.infoMessage) {
            return `
            <div style="padding: 5px 0;">
                <h3 style="font-weight: 600; font-size: 16px; margin-bottom: 4px; color: #1f2937;">Brak danych</h3>
                <p style="font-size: 14px; margin: 0; color: #4b5563;">${data.infoMessage}</p>
            </div>`;
        }

        const attributes = data.attributes;
        const aliases = data.aliases || {};
        const requiredLabels = ['Id działki', 'Typ własności'];

        let hasEssentialData = false;

        if (attributes) {
            for (const [key, value] of Object.entries(attributes)) {
                const label = aliases[key] || key;
                if (requiredLabels.includes(label) && value && value.toString().trim() !== '') {
                    hasEssentialData = true;
                    break;
                }
            }
        }

        if (!hasEssentialData) {
            return `
            <div style="padding: 5px 0;">
                <h3 style="font-weight: 600; font-size: 16px; margin-bottom: 4px; color: #1f2937;">Błąd</h3>
                <p style="font-size: 14px; margin: 0; color: #4b5563;">Nie udało się pobrać danych dla wskazanej lokalizacji.</p>
            </div>`;
        }

        let rows = '';

        for (const [key, value] of Object.entries(attributes)) {
            if (key === '_mapped_owner' || key.startsWith('_debug_')) continue;

            const label = aliases[key] || key;
            if (value && requiredLabels.includes(label)) {
                let displayValue = value;

                if (label === 'Typ własności' && attributes['_mapped_owner']) {
                    displayValue += ' ' + attributes['_mapped_owner'];
                }

                rows += `
                <tr>
                    <td style="padding-right: 15px; color: #666; vertical-align: top;">${label}</td>
                    <td style="font-weight: 500; color: #1f2937;">${displayValue}</td>
                </tr>`;
            }
        }

        return `<table style="font-size: 13px; line-height: 1.5; border-collapse: separate; border-spacing: 0 4px;">${rows}</table>`;
    }

    async function updateMapPosition(latLng) {
        if (!map) initializeMap(latLng.lat, latLng.lng);

        if (!marker) {
            marker = L.marker(latLng, { icon: customMarkerIcon, draggable: true }).addTo(map);
            marker.on('dragend', (e) => updateMapPosition(e.target.getLatLng()));
        } else {
            marker.setLatLng(latLng);
        }

        map.setView(latLng, map.getZoom() < 15 ? 17 : map.getZoom());
        map.panBy([0, -100], { animate: false });

        marker.bindPopup('<div style="padding: 10px; font-size: 14px;">Pobieram dane...</div>', {
            className: 'sip-map-popup',
            minWidth: 250
        }).openPopup();

        if (selectedParcelLayer) {
            map.removeLayer(selectedParcelLayer);
            selectedParcelLayer = null;
        }

        try {
            const data = await fetchSipResults(latLng.lat, latLng.lng);

            const htmlContent = buildPopupHtmlFromTwigLogic(data);

            if (marker) {
                marker.setPopupContent(htmlContent);
            }

            if (data.geometry && data.geometry.rings) {
                drawPolygonFromArcGIS(data.geometry.rings);
            }

        } catch (error) {
            // console.error("Błąd JS:", error);
            const errorHtml = `
                <div style="padding: 5px 0;">
                    <h3 style="font-weight: 600; font-size: 16px; margin-bottom: 4px; color: #1f2937;">Wystąpił błąd</h3>
                    <p style="font-size: 14px; margin: 0; color: #4b5563;">Nie udało się pobrać danych dla wskazanej lokalizacji.</p>
                </div>`;
            if (marker) {
                marker.setPopupContent(errorHtml);
            }
        }
    }

    async function fetchSipResults(lat, lon) {
        //Link na dev - potem sie to usprawni na dynamiczna wartość.
        // const AJAX_ENDPOINT_URL = '/front/proxy/sport/sip-um-map';
        // Link na prod
        const AJAX_ENDPOINT_URL = 'https://www.wroclaw.pl/sport/sip-um-map';

        const response = await fetch(AJAX_ENDPOINT_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                lat: lat,
                lon: lon
            })
        });

        if (!response.ok) {
            throw new Error(`Błąd serwera (${response.status}): ${response.statusText}`);
        }

        const data = await response.json();
        if (!data) {
            throw new Error('Serwer zwrócił pustą odpowiedź.');
        }
        return data;
    }

    function drawPolygonFromArcGIS(rings) {
        const leafletCoords = rings.map(ring => {
            return ring.map(coord => [coord[1], coord[0]]);
        });

        selectedParcelLayer = L.polygon(leafletCoords, {
            color: '#0077B6',
            weight: 3,
            opacity: 1,
            fillColor: '#0077B6',
            fillOpacity: 0.2
        }).addTo(map);
    }

    function initializeMap(initialLat, initialLon) {
        if(map) {
            map.remove();
        }

        map = L.map('map', {
            zoomControl: false
        });

        L.tileLayer('https://maps.dev.wroclaw.pl/hot/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            maxZoom: 19,
            maxNativeZoom: 22
        }).addTo(map);

        // To jest jedyne rozwiązanie problemu z-index. Kontrolki od zoomowania przykrywały popup z wynikiem (Stacking Context)
        L.control.zoom({
            position: 'bottomright'
        }).addTo(map);

        const zoomControl = map.getContainer().querySelector('.leaflet-control-zoom');

        if (zoomControl) {
            zoomControl.style.transition = 'opacity 0.3s ease';

            map.on('popupopen', () => {
                isPopupOpen = true;
                updateZoomControls();
            });

            map.on('popupclose', () => {
                isPopupOpen = false;
                updateZoomControls();
            });
        }

        map.on('click', (e) => updateMapPosition(e.latlng));

        map.setView([initialLat, initialLon], 17);
        map.invalidateSize();
        updateZoomControls();
    }

    initializeMap(51.1079, 17.0385);
    map.panBy([0, -100], { animate: false });
});